import React, { InputHTMLAttributes } from 'react';

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  name?: string;
}

const TextInput: React.FC<TextInputProps> = ({ 
  placeholder, 
  value, 
  onChange, 
  type = 'text',
  name,
  ...rest
}) => {
  return (
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="w-full bg-transparent text-input-custom"
      style={{
        color: 'var(--white, #FFFFFF)',
        textAlign: 'center',
        fontSize: '22px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.275px',
        border: 0,
        outline: 'none',
        padding: '16px 0'
      }}
      {...rest}
    />
  );
};

export default TextInput; 